// ** Initial State
const initialState = {
  allData: [],
  allBooks: [],
  data: [],
  total: 1,
  params: {},
  currentUser: null,
  selectedUser: null,
  selectedBook: null,
  bookEdit: false,
  customPagination: null,
  addonBooks: [],
  addonBookPagination: null,
  currentAddon: null,
  token: JSON.parse(localStorage.getItem("accessToken")),
  found_results: '',
  entries_per_page: '',
  total_results: ''
}

// console.log('sssssssssssss', selectedUser)

const addonSelection = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_SELECTIONBOOKS':
 
 return { ...state, allBooks: action.data, customPagination: action.customTotal, entries_per_page: action.entries_per_page, found_results: action?.found_results, total_results: action?.total_results }
    case 'GET_ALL_SPECIFIC_ADDON_BOOKS':
      console.log(action.data)
      return { ...state, addonBooks: action.data, addonBookPagination: action.customTotal, currentAddon: action.currentAddon }
    case 'GET_BOOK_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_USER':
      console.log(action)
      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
    return {...state, allData: action.data}
    case 'DELETE_BOOK':
      console.log(action.data)
      return { ...state, allBooks: action.data }
    case 'EDITBOOK':
      return {...state, selectedBook: action.data}
    case 'BOOK_PAGE_CHANGE':
      return {...state, allBooks: [], addonBooks: []}
    case 'ADDON_CHANGE':
      // console.log('doifweiut', action.data)
      return {...state, allBooks: [], addonBooks: [], currentAddon: action?.data?.id}
    case 'ADDON_SELECTION_TYPES.UPDATE_SELECTED_BOOKS':
      return {...state, addonBooks: action.payload}
    // case 'START_LOADING':
    //   return {...state, loading: true}
    // case 'END_LOADING':
    //   return {...state, loading: false}
    default:
      return { ...state }
  }
}
export default addonSelection
